import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const ChevronLeft = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M10.9913 11.9996l3.8045 3.8043c.2112.2113.3168.4765.3168.7957s-.1056.5844-.3168.7958c-.2113.2111-.4765.3167-.7957.3167s-.5844-.1056-.7958-.3167l-4.594-4.594c-.1118-.112-.1935-.2364-.2452-.373a1.2013 1.2013 0 01-.0775-.4288c0-.1493.0258-.2922.0775-.4287.0517-.1367.1334-.261.2453-.373l4.5939-4.594c.2114-.2112.4766-.3168.7958-.3168.3192 0 .5844.1056.7957.3168.2112.2113.3168.4765.3168.7957s-.1056.5844-.3168.7958l-3.8045 3.8042z"
    }),
    filledrtl: /*#__PURE__*/React.createElement("path", {
      d: "M12.4088 11.9996l-3.8044 3.8043c-.2112.2113-.3168.4765-.3168.7957s.1056.5844.3168.7958c.2113.2111.4765.3167.7957.3167s.5844-.1056.7957-.3167l4.594-4.594c.1119-.112.1936-.2364.2453-.373a1.2007 1.2007 0 00.0775-.4288c0-.1493-.0258-.2922-.0775-.4287-.0517-.1367-.1334-.261-.2453-.373l-4.594-4.594c-.2113-.2112-.4765-.3168-.7957-.3168s-.5844.1056-.7957.3168c-.2112.2113-.3168.4765-.3168.7957s.1056.5844.3168.7958l3.8044 3.8042z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M10.9913 11.9996l3.8045 3.8043c.2112.2113.3168.4765.3168.7957s-.1056.5844-.3168.7958c-.2113.2111-.4765.3167-.7957.3167s-.5844-.1056-.7958-.3167l-4.594-4.594c-.1118-.112-.1935-.2364-.2452-.373a1.2013 1.2013 0 01-.0775-.4288c0-.1493.0258-.2922.0775-.4287.0517-.1367.1334-.261.2453-.373l4.5939-4.594c.2114-.2112.4766-.3168.7958-.3168.3192 0 .5844.1056.7957.3168.2112.2113.3168.4765.3168.7957s-.1056.5844-.3168.7958l-3.8045 3.8042z"
    }),
    strokertl: /*#__PURE__*/React.createElement("path", {
      d: "M12.4088 11.9996l-3.8044 3.8043c-.2112.2113-.3168.4765-.3168.7957s.1056.5844.3168.7958c.2113.2111.4765.3167.7957.3167s.5844-.1056.7957-.3167l4.594-4.594c.1119-.112.1936-.2364.2453-.373a1.2007 1.2007 0 00.0775-.4288c0-.1493-.0258-.2922-.0775-.4287-.0517-.1367-.1334-.261-.2453-.373l-4.594-4.594c-.2113-.2112-.4765-.3168-.7957-.3168s-.5844.1056-.7957.3168c-.2112.2113-.3168.4765-.3168.7957s.1056.5844.3168.7958l3.8044 3.8042z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
ChevronLeft.displayName = "ChevronLeftIcon";

export { ChevronLeft, ChevronLeft as default };
